
'use strict';//Indicating browser should run only in java script mode

var EMREHRChatMessages = angular.module('EMR.EHRChatMessages', ['EMR.Admin', 'rcForm', 'ngFileUpload'])